export default "__VITE_ASSET__DUUH0ntw__"